import React from 'react'
import { SnackbarContextType } from 'src/components/snackbar/types'

const SnackbarContext = React.createContext<SnackbarContextType>({} as SnackbarContextType)

export default SnackbarContext
